"use client";
import "../../chunk-MMUBH76A.js";
import { useInternalClient } from "../../provider/hooks/utils/useInternalClient.js";
import { useExternalWallets } from "../providers/ExternalWalletContext.js";
import { useModalStore } from "../stores/index.js";
import { getAddFundsStep, ModalStep } from "../utils/steps.js";
const useGoBack = () => {
  const refs = useModalStore((state) => state.refs);
  const currentStep = refs.currentStep.current;
  const setStep = useModalStore((state) => state.setStep);
  const accountAddFundTab = useModalStore((state) => state.accountAddFundTab);
  const decrementStep = useModalStore((state) => state.decrementStep);
  const resetState = useModalStore((state) => state.resetState);
  const { setChainIdSwitchingTo, disconnectExternalWallet } = useExternalWallets();
  const client = useInternalClient();
  const goBack = () => {
    if (currentStep === ModalStep.ADD_FUNDS_AWAITING) {
      setStep(getAddFundsStep(accountAddFundTab));
    } else {
      decrementStep();
    }
    switch (currentStep) {
      case ModalStep.AUTH_MAIN:
      case ModalStep.AUTH_MORE:
      case ModalStep.EX_WALLET_SELECTED:
      case ModalStep.EXTERNAL_WALLET_VERIFICATION: {
        resetState();
        if (client.isExternalWalletAuth) {
          disconnectExternalWallet();
        }
        break;
      }
      case ModalStep.CHAIN_SWITCH: {
        setChainIdSwitchingTo();
        break;
      }
    }
  };
  return goBack;
};
export {
  useGoBack
};
